import { SeverityEnum } from '../models/severity';

export const SeverityLabelPipe = severity => {
    switch (severity) {
        case SeverityEnum.LOW:
            return 'Low';
        case SeverityEnum.MEDIUM:
            return 'Medium';
        case SeverityEnum.HIGH:
            return 'High';
        default:
            return severity;
    }
};
